module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-modal"
  }, [_c('div', {
    staticClass: "video-modal__overlay",
    on: {
      "click": _vm.close
    }
  }, [_c('div', {
    staticClass: "video-modal__container"
  }, [_c('div', {
    staticClass: "video-modal__close",
    on: {
      "click": _vm.close
    }
  }, [_c('span'), _c('span')]), _c('div', {
    staticClass: "video-modal__content"
  }, [_c('video', {
    staticClass: "video-modal__video",
    attrs: {
      "controls": "controls"
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.props.source,
      "type": "video/mp4"
    }
  }), _vm._v("Your browser does not support video.")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-786e3e46","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/modal/video-modal/video-modal.pug
// module id = 585
// module chunks = 1